import { Checkbox, Collapse, Space, Typography } from "antd";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectedViews } from "../../constant/table";
import { GREEN, LIGHT_BLUE, NEW_BLUE } from "../../constant/colors";
import { DateRangeFilter } from "../filter/DateRangeFilter";
import { ALL_TIMES } from "../../constant/filters";
import { selectFilters, selectFiltersInputs, selectSelectedView } from "../../store/selector";
import ACTIONS from "../../store/action";

const { Text, Title } = Typography;
const { Panel } = Collapse;

export const PatientActionsFiltersPanel = ({ handleInputDate, resetDatesToDefault, filtersVisible }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dates } = useSelector(selectFilters);
  const filters = useSelector(selectFilters);
  const filtersInputs = useSelector(selectFiltersInputs);
  const selectedView = useSelector(selectSelectedView);

  const setFiltersInputs = (filterName, value) => dispatch(ACTIONS.setFiltersInputs(filterName, value));
  const setFiltersAct = (filters) => dispatch(ACTIONS.setFiltersAction(filters));

  const { inviteSentDateRange, patientViewedDateRange } = dates;

  const isInvitationFiltersActive = () => {
    const inviteSentValue = dates?.inviteSentDateRange?.value;
    const patientViewedValue = dates?.patientViewedDateRange?.value;
    const neverViewed = filters.patientNeverViewed;

    return inviteSentValue !== ALL_TIMES || patientViewedValue !== ALL_TIMES || !!neverViewed;
  };

  const handlePatientNeverViewedChange = (checked) => {
    setFiltersInputs("patientNeverViewed", checked);
    setFiltersAct({ ...filters, patientNeverViewed: checked });
  };

  return (
    selectedView === selectedViews.patientActions && (
      <Collapse ghost expandIconPosition="end" style={{ display: !filtersVisible ? "none" : undefined }}>
        <Panel
          header={
            <Title level={5} style={{ color: NEW_BLUE }}>
              {t("tableFilters.invitation")}
              {isInvitationFiltersActive() && (
                <div
                  style={{
                    position: "absolute",
                    background: GREEN,
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    left: "247px",
                    top: "24px"
                  }}
                />
              )}
            </Title>
          }
        >
          <Space size={16} direction="vertical" style={{ width: "100%" }}>
            {/* Invite Sent Date */}
            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.invite_sent_date")}
              </Text>
              <DateRangeFilter
                id="filter_invite_sent_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("inviteSentDateRange", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "inviteSentDateRange", value)
                }
                allowClear={true}
                onClear={() => resetDatesToDefault("inviteSentDateRange", ALL_TIMES)}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="inviteSentDateFilters"
                timeRange={inviteSentDateRange}
              />
            </Space>

            {/* Patient Viewed Date */}
            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.patient_viewed_date")}
              </Text>
              <DateRangeFilter
                id="filter_patient_viewed_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("patientViewedDateRange", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "patientViewedDateRange", value)
                }
                allowClear={true}
                onClear={() => resetDatesToDefault("patientViewedDateRange", ALL_TIMES)}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="patientViewedDateFilters"
                timeRange={patientViewedDateRange}
                disabled={filtersInputs.patientNeverViewed}
              />
            </Space>

            {/* Patient Never Viewed Checkbox */}
            <Space id="filter_patient_never_viewed">
              <Checkbox
                checked={filtersInputs.patientNeverViewed}
                onChange={(e) => handlePatientNeverViewedChange(e.target.checked)}
                disabled={patientViewedDateRange?.value !== ALL_TIMES}
                id="patient_never_viewed_checkbox"
              >
                <Text style={{ color: LIGHT_BLUE }}>{t("tableFilters.patient_never_viewed")}</Text>
              </Checkbox>
            </Space>
          </Space>
        </Panel>
      </Collapse>
    )
  );
};
